/**
 * Frontend-only allowlist for users restricted to a subset of capabilities.
 * A user not listed here has access to every capability by default.
 * A listed user only gets the capabilities explicitly included in their array
 * (reference keys from Capability, e.g. Capability.BANK_ACCOUNTS.MANAGE_INTEGRATIONS).
 *
 * This is a UI convenience, not a security boundary - remove an entry once
 * the equivalent restriction is enforced by a real backend permission.
 */
export const RESTRICTED_USER_CAPABILITIES: Record<string, string[]> = {
  'ad@deben.io': [],
};
